import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 * 
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { AbWebServices } from "abweb/service/AbWebServices";
import { LocaleManager } from "abweb/service/locale/LocaleManager";
import { LocaleUtils } from "abweb/utils/LocaleUtils";

/**
 * A simple setting for managing the user's preferred language.
 */
export class LanguageUserSetting {
  constructor() {
    _defineProperty(this, "isAvailable", true);
    _defineProperty(this, "defaultValue", undefined);
    _defineProperty(this, "requiresReload", true);
  }
  get displayName() {
    return AbReactResources.userSetting_language_displayName();
  }
  get value() {
    return LocaleManager.languageLocale;
  }
  get valueLabel() {
    return LocaleUtils.localeDisplayName();
  }
  async setValue(localeTag) {
    await AbWebServices.localeService.setPreferredLocale(localeTag);
  }
  async removeValue() {
    await AbWebServices.localeService.setPreferredLocale(null);
  }
  async initialize() {
    return true;
  }
}
//# sourceMappingURL=LanguageUserSetting.js.map
